import './App.css';
import Navbar from './components/Navbar';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Pages/Home';
import Tim from './components/Pages/Tim';
import Galerija from './components/Pages/Galerija';
import Usluge from './components/Pages/Usluge';
import Kontakt from './components/Pages/Kontakt';
import PolitikaPrivatnosti from './components/Pages/PolitikaPrivatnosti';

function App() {
  return (
    <>
    <Router>
      <Navbar />
      <Routes>
        <Route path='/' exact Component={Home}/>
        <Route path='/usluge' exact Component={Usluge}/>
        <Route path='/galerija' exact Component={Galerija}/>
        <Route path='/tim' exact Component={Tim}/>
        <Route path='/kontakt' exact Component={Kontakt}/>
        <Route path='/politika-privatnosti' exact Component={PolitikaPrivatnosti}/>
      </Routes>
    </Router>
    </>
  );
}

export default App;
